'use strict';

var secp256k1 = require('secp256k1');

var multihashing = require('multihashing-async');

var setImmediate = require('async/setImmediate');

var HASH_ALGORITHM = 'sha2-256';

module.exports = function (randomBytes) {
  var privateKeyLength = 32;

  function generateKey(callback) {
    var done = function done(err, res) {
      return setImmediate(function () {
        return callback(err, res);
      });
    };

    var privateKey;

    do {
      privateKey = randomBytes(32);
    } while (!secp256k1.privateKeyVerify(privateKey));

    done(null, privateKey);
  }

  function hashAndSign(key, msg, callback) {
    var done = function done(err, res) {
      return setImmediate(function () {
        return callback(err, res);
      });
    };

    multihashing.digest(msg, HASH_ALGORITHM, function (err, digest) {
      if (err) {
        return done(err);
      }

      try {
        var sig = secp256k1.sign(digest, key);
        var sigDER = secp256k1.signatureExport(sig.signature);
        return done(null, sigDER);
      } catch (err) {
        done(err);
      }
    });
  }

  function hashAndVerify(key, sig, msg, callback) {
    var done = function done(err, res) {
      return setImmediate(function () {
        return callback(err, res);
      });
    };

    multihashing.digest(msg, HASH_ALGORITHM, function (err, digest) {
      if (err) {
        return done(err);
      }

      try {
        sig = secp256k1.signatureImport(sig);
        var valid = secp256k1.verify(digest, sig, key);
        return done(null, valid);
      } catch (err) {
        done(err);
      }
    });
  }

  function compressPublicKey(key) {
    if (!secp256k1.publicKeyVerify(key)) {
      throw new Error('Invalid public key');
    }

    return secp256k1.publicKeyConvert(key, true);
  }

  function decompressPublicKey(key) {
    return secp256k1.publicKeyConvert(key, false);
  }

  function validatePrivateKey(key) {
    if (!secp256k1.privateKeyVerify(key)) {
      throw new Error('Invalid private key');
    }
  }

  function validatePublicKey(key) {
    if (!secp256k1.publicKeyVerify(key)) {
      throw new Error('Invalid public key');
    }
  }

  function computePublicKey(privateKey) {
    validatePrivateKey(privateKey);
    return secp256k1.publicKeyCreate(privateKey);
  }

  return {
    generateKey: generateKey,
    privateKeyLength: privateKeyLength,
    hashAndSign: hashAndSign,
    hashAndVerify: hashAndVerify,
    compressPublicKey: compressPublicKey,
    decompressPublicKey: decompressPublicKey,
    validatePrivateKey: validatePrivateKey,
    validatePublicKey: validatePublicKey,
    computePublicKey: computePublicKey
  };
};